export const track = (event_name, props = {}) => {
  // const new_props = { host: window.location.host, ...props }
  // console.log(new_props)
  // window.analytics.track(event_name, new_props)
};

export const identify = (email, props = {}) => {
  // window.analytics.identify(email, props)
};
